<template>
  <div @click="jump(imageValue.jumpPath)">
    <img
      class="img"
      :src="imageValue.imagePath || defaultImage"
      :style="aStyle"
    />
  </div>
</template>

<script>
export default {
  name: 'McImg',

  props: {
    imageValue: {
      type: Object,
      default: () => {}
    },
    imageStyle: {
      type: Object,
      default: () => {}
    },
    viewStatus: {
      type: Number
    }
  },

  data() {
    return {
      height: 360,
      defaultImage:
        'https://yxfile.3k.com/2023/02/23/upload_6u8q2zl46sizzcefxgkg9gbti1h5y3ju.png'
    };
  },
  computed: {
    aStyle() {
      return {
        height: this.$unit(this.height)
      };
    }
  },
  watch: {
    imageValue() {
      this.init();
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      let img = new Image();
      img.onload = () => {
        let h = img.height;
        this.height = h;
      };
      img.src = this.imageValue.imagePath;
    },
    jump(url) {
      if (this.viewStatus == 1) return;
      if (!url || url == '') return;
      window.open(url, '_blank');
    }
  }
};
</script>

<style lang="scss" scoped>
.img {
  display: block;
  width: 100%;
}
</style>
